module.exports = __webpack_public_path__ + "img/060.b49bbb9d.png";